import { type JSX } from 'solid-js'
import { CorisUserProvider } from './coris-user.provider'

export const CorisProvider = (props: { children: JSX.Element }): JSX.Element => {
  return <CorisUserProvider>{props.children}</CorisUserProvider>
}
